$(document).ready(function(){
    handleDisclosureClicks();
    handleDisclosureAnchorOnLoad();
    handleMultislideCarrousels();
    handleMultislideCarrousel(6,'.carousel-item-tile');
    handleVideoTestimonials();
    handleSplitScrollSearch();
    handleAccordionBlock();
    validateNinjaFormsLetterOnlyInput();
})

//Define icontains as case-insensitive search ignoring diacritics
$.expr[':'].icontains = function(a, i, m) {
    const needle = jQuery(a).text().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    const haystack = m[3].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()
    return needle.indexOf(haystack) >= 0;
};

function handleDisclosureClicks(){
    //Check that the block is present
    if(!!document.getElementById('disclousures-collapse-body')){
        const disclosuresCollapse = new bootstrap.Collapse('#disclousures-collapse-body',{
            toggle: false
        });
        $("a[href='#disclosures'], a[href^='#disclosure-']").on('click', function(a) {
            const targetHash = a.currentTarget.hash;
            if (!isDisclosureHash(targetHash)) return;

            a.preventDefault();
            openDisclosuresAndScroll(disclosuresCollapse, targetHash);
        });
    }
}

function handleDisclosureAnchorOnLoad(){
    //No disclosure link in URL, nothing to do
    if (!isDisclosureHash(location.hash)) return;
    //Check that the block is present
    if(!!document.getElementById('disclousures-collapse-body')){
        const disclosuresCollapse = new bootstrap.Collapse('#disclousures-collapse-body',{
            toggle: false
        });
        openDisclosuresAndScroll(disclosuresCollapse, location.hash);
    }
}

function isDisclosureHash(hash) {
    return !!hash && (hash === '#disclosures' || /^#disclosure-[\d*]+$/i.test(hash));
}

function openDisclosuresAndScroll(disclosuresCollapse, targetHash) {
    var collapseElement = $('#disclousures-collapse-body');
    var targetElement = document.getElementById(targetHash.replace("#",""));
    if (!targetElement) return;

    if(collapseElement.hasClass( "show" )){
        targetElement.scrollIntoView(true);
        return;
    }

    collapseElement.one('shown.bs.collapse',function (){
        targetElement.scrollIntoView(true);
    });
    disclosuresCollapse.show();
}

function handleMultislideCarrousels(){
    let carousels = document.querySelectorAll('[id^=\'articleCarousel-\']');
    carousels.forEach(carousel => {
        handleMultislideCarrousel(3,'.carousel-item-article-'+carousel.getAttribute('data-carousel-id'));
    });

    let videoTestimonialCarousels = document.querySelectorAll('[id^=\'videoTestimonialCarousel-\']');
    videoTestimonialCarousels.forEach(carousel => {
        handleMultislideCarrousel(3,'.carousel-item-video-testimonial-'+carousel.getAttribute('data-carousel-id'));
    });
}

function handleMultislideCarrousel(slides,selector){
    let items = document.querySelectorAll(selector);
    items.forEach((el) => {
        const minPerSlide = slides;
        let next = el.nextElementSibling
        for (var i=1; i<minPerSlide; i++) {
            if (!next) {
                // wrap carousel by using first child
                next = items[0]
            }
            let cloneChild = next.cloneNode(true)
            el.appendChild(cloneChild.children[0])
            next = next.nextElementSibling
        }
    })
}

function waitForTransition(el, ms) {
    return new Promise((resolve) => {
        let done = false;
        const finish = () => {
            if (done) return;
            done = true;
            el.removeEventListener('transitionend', onEnd);
            resolve();
        };
        const onEnd = (e) => {
            if (e.propertyName === 'opacity') finish();
        };
        el.addEventListener('transitionend', onEnd);
        setTimeout(finish, ms + 50); // fallback
    });
}

function handleAccordionBlock() {
    if ($('.accordion-block').length && $('.accordion-w-image').length) {
        document.querySelectorAll('.accordion-block').forEach(moduleEl => {
            const mediaEl = moduleEl.querySelector('.accordion-media');
            if (!mediaEl) return;

            moduleEl.querySelectorAll('.accordion-collapse-img').forEach(collapse => {
                collapse.addEventListener('show.bs.collapse', async function () {
                    const newImage = this.getAttribute('data-image');
                    if (!newImage) return;

                    const newUrl = new URL(newImage, window.location.href).href;
                    const currentBg = getComputedStyle(mediaEl).backgroundImage; // e.g. url("...")
                    const match = currentBg && currentBg !== 'none'
                        ? currentBg.match(/url\(["']?(.*?)["']?\)/i)
                        : null;
                    const currentUrl = match ? new URL(match[1], window.location.href).href : '';

                    if (currentUrl === newUrl) return;
                    mediaEl.classList.add('fade-out');
                    await waitForTransition(mediaEl, 400);
                    mediaEl.style.backgroundImage = `url("${newUrl}")`;
                    try {
                        await preloadImage(newUrl);
                    } catch (_) {
                        // even if preload fails, still swap
                    }
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            mediaEl.classList.remove('fade-out');
                        });
                    });
                });
            });
        });
    }
}

function preloadImage(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve();
        img.onerror = reject;
        img.src = url;
    });
}

function handleVideoTestimonials() {
    document.querySelectorAll('.video-testimonial-player').forEach(player => {
        player.setAttribute('data-poster-html', player.innerHTML);

        player.addEventListener('click', function () {
            const youtubeId = this.getAttribute('data-youtube-id');
            if (!youtubeId || this.querySelector('iframe')) return;
            const carousel = this.closest('.carousel');

            if (carousel) {
                stopVideoTestimonials(carousel);
            }

            const iframe = document.createElement('iframe');
            iframe.setAttribute('src', 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&rel=0&playsinline=1');
            iframe.setAttribute('title', this.getAttribute('aria-label') || 'Video testimonial');
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
            iframe.setAttribute('allowfullscreen', '');

            this.innerHTML = '';
            this.appendChild(iframe);
            this.classList.add('is-playing');

            if (carousel) {
                carousel.setAttribute('data-video-testimonial-playing', 'true');
            }

            if (carousel && window.bootstrap) {
                const carouselInstance = bootstrap.Carousel.getOrCreateInstance(carousel, {
                    interval: false,
                    ride: false
                });
                carouselInstance.pause();
            }
        });
    });

    document.querySelectorAll('[id^=\'videoTestimonialCarousel-\']').forEach(carousel => {
        carousel.querySelectorAll('.carousel-control-prev, .carousel-control-next').forEach(control => {
            control.addEventListener('click', function () {
                stopVideoTestimonials(carousel);
            });
        });

        carousel.addEventListener('slide.bs.carousel', function (event) {
            if (this.querySelector('.video-testimonial-player.is-playing')) {
                event.preventDefault();
            }
        });

        carousel.addEventListener('slid.bs.carousel', function () {
            stopVideoTestimonials(this);
        });
    });
}

function stopVideoTestimonials(container) {
    container.querySelectorAll('.video-testimonial-player.is-playing').forEach(player => {
        const posterHtml = player.getAttribute('data-poster-html');
        if (posterHtml) {
            player.innerHTML = posterHtml;
        }
        player.classList.remove('is-playing');
    });
    container.removeAttribute('data-video-testimonial-playing');
}

function validateNinjaFormsLetterOnlyInput() {
    if($('.schedule-meeting-block').length) {
        var contactFormValidationController = Marionette.Object.extend( {
            initialize: function() {
                //Handle validations
                this.listenTo( Backbone.Radio.channel( 'submit' ), 'validate:field', this.validateRequired );
                this.listenTo( Backbone.Radio.channel( 'fields' ), 'change:modelValue', this.validateRequired );
            },

            validateRequired: function ( model ){
                //Check for fields that allow letters only
                if(model && model.attributes.key.toLowerCase().includes('-letters-only')){
                    const lettersOnlyRegex = /\p{N}|\p{P}/gu;
                    const notLettersOnly = lettersOnlyRegex.test(model.attributes.value);
                    if(notLettersOnly){
                        Backbone.Radio.channel( 'fields' ).request( 'add:error', model.get( 'id' ), 'letters-only-error', 'Only letters are allowed.' );
                    }else{
                        Backbone.Radio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'letters-only-error');
                    }
                //validate international phone numbers
                }else if(model && model.attributes.key.toLowerCase().includes('phone-number-international')){
                    let number = model.attributes.value;
                    var numbersOnly = /^\d+$/;
                    var isNumbersOnly = numbersOnly.test(number);
                    var phoneToValidate;
                    if(isNumbersOnly){
                        let countryCode = $('.phone-number-country-code').val();
                        if(countryCode){
                            var parenthesisExtract = /\(([^)]+)\)/;
                            var matches = parenthesisExtract.exec(countryCode);
                            if(matches) countryCode = matches[1];
                        }
                        if(countryCode) number = countryCode +''+ number;
                        phoneToValidate = new libphonenumber.parsePhoneNumber(number,'US');
                    }
                    if(!isNumbersOnly || !phoneToValidate.isPossible()){
                        Backbone.Radio.channel( 'fields' ).request( 'add:error', model.get( 'id' ), 'phone-number-invalid', 'Phone number is invalid.' );
                    }else{
                        Backbone.Radio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'phone-number-invalid');
                    }
                //This is in place just so a change to the country code drop down triggers a revalidation of the phone number
                }else if(model && model.attributes.key.toLowerCase().includes('phone-number-country-code')){
                    let phoneInput = $('input[name="phone"]');
                    const currentNumber = phoneInput.val();
                    phoneInput.val('').trigger('change');
                    phoneInput.val(currentNumber).trigger('change');
                }
            },
        });

        new contactFormValidationController();
    }
}

function handleSplitScrollSearch() {
    if($('.split-scroll-block').length && $('#split-scroll-search').length){
        $('#split-scroll-search').on('input', function(e) {
            var rows = $(".split-scroll-content").find("tr").hide();
            var searchWords = this.value.split(" ");
            $.each(searchWords, function(i, v) {
                rows.filter(":icontains('" + v + "')").show();
            });
            var tabPanes = $(".split-scroll-content").find(".tab-pane").show();
            $.each(tabPanes, function (index,tabPane){
                if(!$(this).find("tr:visible").length) $(this).hide();
            });
        });
    }
}
